import { render, staticRenderFns } from "./PrettyJson.vue?vue&type=template&id=4df89f92"
import script from "./PrettyJson.vue?vue&type=script&lang=js"
export * from "./PrettyJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports